import { cn } from '@/utils/cn';

const TONES: Record<string, string> = {
  ACTIVE: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  CONFIRMED: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  COMPLETED: 'bg-slate-100 text-slate-700 ring-slate-200',
  REQUESTED: 'bg-amber-50 text-amber-900 ring-amber-200',
  FULL: 'bg-amber-50 text-amber-900 ring-amber-200',
  OPEN: 'bg-amber-50 text-amber-900 ring-amber-200',
  REJECTED: 'bg-red-50 text-red-800 ring-red-200',
  CANCELLED: 'bg-red-50 text-red-800 ring-red-200',
  CANCELLED_BY_PASSENGER: 'bg-red-50 text-red-800 ring-red-200',
  CANCELLED_BY_DRIVER: 'bg-red-50 text-red-800 ring-red-200',
  NO_SHOW: 'bg-red-50 text-red-800 ring-red-200',
};

export function StatusBadge({ status }: { status: string }) {
  return (
    <span className={cn('inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ring-1', TONES[status] ?? 'bg-slate-100 text-slate-700 ring-slate-200')}>
      {status.replace(/_/g, ' ').toLowerCase().replace(/^\w/, (c) => c.toUpperCase())}
    </span>
  );
}
